const actions = {
  FETCH_ADVISOR: 'advisor/FETCH_ADVISOR',
}

export default actions
